import styled from 'styled-components';

import hair from '../../../assets/hair.svg';
import media from '../../../styles/media.style';
import { BLACK, BG_GRAY, PAGE_WIDTH, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';

export const Section = styled.section`
  align-items: center;
  background: center / cover no-repeat url(${hair}), ${BG_GRAY.COMMON_1};
  display: flex;
  flex-direction: column;
  padding: 50px 0;
  margin: 50px 0;

  ${media.tabletL`
    padding: 90px 0;
  `};
`;

export const Title = styled.div`
  margin-bottom: 25px;
  position: relative;
  text-transform: uppercase;

  &::after {
    background-color: #333;
    bottom: -25px;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 0 ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    flex-direction: row;
    margin-top: 90px;
  `};
`;

export const DescriptionWrapper = styled.div`
  flex: 1;
`;

export const Description = styled.div`
  color: ${BLACK};
  width: 100%;

  h1,
  h2,
  h3,
  p {
    text-align: left;
    font-size: 18px;
    line-height: 1.39;
    letter-spacing: 0.1px;
    margin: 15px 0 0 0;

    &:first-child {
      margin-top: 0;
    }
  }

  h1,
  h2,
  h3 {
    font-size: 24px;
    margin-top: 0;
  }

  ${media.tabletL`
    width: 80%;
  `};
`;

export const ImageWrapper = styled.div`
  height: fit-content;
  flex: 1;
  width: 100%;
  order: -1;

  ${media.tabletL`
    order: 0;
  `};
`;

export const TreatmentsWrapper = styled.div`
  max-width: ${PAGE_WIDTH}px;
  overflow-x: scroll;
  padding-bottom: 15px;
  width: 100%;

  ${media.tabletL`
    overflow-x: hidden;
    padding: 0 100px;
  `};

  ${media.desktop`
    padding: 0 190px;
  `};
`;

export const Treatments = styled.div`
  display: flex;
  margin-top: 35px;
  padding-left: 20px;
  width: max-content;

  ${media.tabletL`
    flex-direction: column;
    padding-left: 0;
    width: 100%;
  `};
`;

export const Treatment = styled.div`
  background-color: white;
  display: grid;
  grid-gap: 20px 0;
  grid-template-columns: 1fr;
  margin-left: 20px;
  padding: 20px;
  width: calc(100vw - 60px);

  ${media.tabletL`
    grid-gap: 15px 50px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 25px 1fr 25px;
    margin-left: 0;
    margin-top: 20px;
    padding: 50px 110px 50px 50px;
    width: 100%;
  `};

  ${media.desktop`
    grid-gap: 15px 75px;
  `};

  &:first-child {
    margin-left: 0;
  }
`;

export const TreatmentImage = styled.div`
  ${media.tabletL`
    grid-row-end: span 3;
  `};
`;

export const TreatmentName = styled.div`
  font-family: FuturaStd;
  font-size: 15px;
  line-height: 1.27;
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 18px;
    font-weight: 500;
    grid-column-end: span 2;
  `};
`;

export const TreatmentDescription = styled.div`
  font-family: FuturaStd;
  font-size: 15px;
  line-height: 1.33;

  ${media.tabletL`
    grid-column-end: span 2;
  `};
`;

export const TreatmentDuration = styled.div`
  font-family: FuturaStd;
  font-size: 15px;

  ${media.tabletL`
    align-self: end;
  `};
`;

export const TreatmentLink = styled.div`
  cursor: pointer;
  font-family: FuturaStd;
  font-size: 11px;
  font-weight: bold;
  text-decoration: underline;
  text-transform: uppercase;

  ${media.tabletL`
    place-self: end;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/RangePage/RangeTreatments/RangeTreatments.style.js